import { CampaignAnalyticsReport } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import { MetaTableStyle } from '@features/executive-report/domain/meta-table-style';
import { themeV2 } from '@features/executive-report/domain/theme-v2';
import { brandLocationsTable } from '@features/executive-report/subdomains/visitation/slides/top-states-dmas-locations/brand-locations-table';
import { dmasTable } from '@features/executive-report/subdomains/visitation/slides/top-states-dmas-locations/dmas-table';
import { statesTable } from '@features/executive-report/subdomains/visitation/slides/top-states-dmas-locations/states-table';
import { noBorder } from '@features/executive-report/subdomains/visitation/slides/top-states-dmas-locations/table-utils';
import { slideMasters } from '@features/executive-report/utils/slide-masters';
import { Slide } from '@features/powerpoint';

export const metaTableStyle = {
  headerRowBackgroundColor: themeV2.colors.lightBlue,
  headerRowFontColor: themeV2.colors.metricBlue,
  cellFontColor: themeV2.colors.metricBlue,
  evenRowFillColor: themeV2.colors.lightGray,
  oddRowFillColor: themeV2.colors.white,
  headerRowBorderOptions: noBorder,
  cellBorderOptions: [
    {
      type: 'solid',
      color: themeV2.colors.metricBlue,
      pt: 1,
    },
    noBorder,
    noBorder,
    noBorder,
  ],
} as const satisfies MetaTableStyle;

type SlideProps = {
  stateVisits: CampaignAnalyticsReport['stateVisits'];
  dmaVisits: CampaignAnalyticsReport['dmaVisits'];
  brandLocationVisits: CampaignAnalyticsReport['brandLocationVisits'];
};

export const topStatesDmasLocationsSlide = (props: SlideProps): Slide => {
  return {
    slideMaster: slideMasters.light,
    color: themeV2.colors.metricBlue,
    texts: [
      {
        text: 'Top 10 States, DMAs & Locations',
        options: {
          fontSize: 36,
          bold: true,
          h: 0.75,
          w: 12.67,
          x: 0.33,
          y: 0.25,
        },
      },
    ],
    tables: [
      statesTable(props.stateVisits, metaTableStyle),
      dmasTable(props.dmaVisits, metaTableStyle),
      brandLocationsTable(props.brandLocationVisits, metaTableStyle),
    ],
  };
};
